import { createSlice } from "@reduxjs/toolkit";
import generateLink from "@custom/rtk-apis/media-service/shareStudyLink";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""
};

const generateStudyLinkSlice = createSlice({
  name: "generateStudyLinkSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(generateLink.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(generateLink.fulfilled, (state, { payload }) => {
        console.log("Fulfilled for generate study  slice",payload)
        state.loading = false;
        state.status = '201';
        state.result = payload;
        state.msg = 'Link generated Successfully.';
        state.error=''
      })
      .addCase(generateLink.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
        state.error = 'Something went wrong!'
      });
  },
});

export default generateStudyLinkSlice.reducer;
